<template>
  <div style="margin-top: -13px">
    <v-container fluid>
      <v-card elevation="0">
        <v-form novalidate ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-card
                class="mx-5 mt-5 transparent"
                elevation="0"
                min-width="250"
              >
                <v-text-field
                  filled
                  label="Palavra-passe actual"
                  class="purple-input"
                  v-model="actualPassword"
                  :rules="pwdRules"
                  required
                  :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (value = !value)"
                  :type="value ? 'password' : 'text'"
                />
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="mt-n8 mx-5">
              <v-btn
                class="mx-0 font-weight-light"
                color="primary"
                text
                @click="upPwd"
              >
                Alterar Palavra-passe
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import eventBus from "../../../../main";

export default {
  name: "UpdatePassword",
  data: () => ({
    actualPassword: "",
    valid: true,
    value: true,
    pwdRules: [
      v => !!v || "Palavra-passe é requerida",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter",
      v =>
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{6,15}$).*$/.test(v) ||
        ""
    ]
  }),
  methods: {
    upPwd() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("setOldPwdClient", this.actualPassword);
        eventBus.$emit("openSecurity", true);
      }
    }
  }
};
</script>

<style scoped></style>
